import { SHARED_MODULES } from 'shared/rollbar/shared_modules_prefixes';
import { TEAMS } from 'shared/rollbar/global_prefixes';
import { logError } from 'client/javascript/util/logger';
import { setupBrowseByNeedsModule } from 'client/javascript/pages/shared/sections/hero_container/browse_by_needs';
import { setupHeroModule } from 'client/javascript/pages/shared/sections/hero_container/hero';
import { getSearchWidgetInstance } from 'client/javascript/pages/shared/sections/hero_container/search_widget';

export const LOGGING_CONFIG = {
  prefix: `${SHARED_MODULES}[HeroContainerUI]`,
  team: TEAMS.MARKETING
};

export const SELECTORS = {
  MODULE: '.hero-container'
};

export const setupHeroContainerSection = async () => {
  try {
    const moduleDomNode = document.querySelector(SELECTORS.MODULE);

    if (!moduleDomNode) {
      return;
    }
    const searchWidgetInstance = getSearchWidgetInstance();

    await Promise.all([searchWidgetInstance.setupFilters(), setupBrowseByNeedsModule(), setupHeroModule()]);
  } catch (error) {
    logError(`${LOGGING_CONFIG.prefix}[setupHeroContainerSection()] failed`, error, {
      team: LOGGING_CONFIG.team
    });
  }
};
